/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="b2f4b2ea-5a3f-441f-916d-3d1056f3e2f4" width="16.5" height="10.35" viewBox="0 0 16.5 10.35" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g id="a11c384a-e07e-43df-8943-9a284b1eab64">
    <g id="bbdf2637-3d21-4860-86b5-6c1e06e56096">
      <g id="e79d5ea9-e3b1-4fe5-a7af-aa2a97d5baf0">
        <g id="bdef1b4e-1993-41d3-b450-4e6d7b3d2671">
          <path id="f844314c-e270-423a-b4bd-59b28d86c70e" d="M13.09.47l.07.08,4,4.54a.75.75,0,0,1,.06.9l-.07.09-4,4.33A.74.74,0,0,1,12,9.5l.07-.09L14.9,6.33H1.56a.73.73,0,0,1-.1-1.46H15L12.06,1.51a.73.73,0,0,1,0-1l.08-.07A.73.73,0,0,1,13.09.47Z" transform="translate(-0.82 -0.29)" style={{fill: "#1570bc"}} className="icon-fill"/>
        </g>
      </g>
    </g>
  </g>
</svg>

    );
  }
}

Icon.displayName = 'ArrowRightIcon';

export default Icon;
